import React, { useEffect, useRef, useState } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


import fieldHarvest1 from '../../assets/agricversedeviceimg/Field harvest_1.jpg';
import img20240918Burst0005 from '../../assets/agricversedeviceimg/IMG_20240918_083133967_BURST0005.jpg';
import img20240924_155616_465 from '../../assets/agricversedeviceimg/IMG_20240924_155616_465.jpg';
import img20240928_101509_795 from '../../assets/agricversedeviceimg/IMG_20240928_101509_795.jpg';
import img20240928_101542_366 from '../../assets/agricversedeviceimg/IMG_20240928_101542_366.jpg';
import img20240930_142312_483 from '../../assets/agricversedeviceimg/IMG_20240930_142312_483.jpg';
import img20240930_142320_959 from '../../assets/agricversedeviceimg/IMG_20240930_142320_959.jpg';
import img20241001_123740_344 from '../../assets/agricversedeviceimg/IMG_20241001_123740_344.jpg';
import img20241001_123901_897 from '../../assets/agricversedeviceimg/IMG_20241001_123901_897.jpg';
import img20250106_151509_066 from '../../assets/agricversedeviceimg/IMG_20250106_151509_066.jpg';
import img20250408_075039_133 from '../../assets/agricversedeviceimg/IMG_20250408_075039_133.jpg';
import img20250408_075041_574 from '../../assets/agricversedeviceimg/IMG_20250408_075041_574.jpg';
import img20250615_181910_807 from '../../assets/agricversedeviceimg/IMG_20250615_181910_807.jpg';
import img20250620_094314_385 from '../../assets/agricversedeviceimg/IMG_20250620_094314_385.jpg';
import img20250620_094322_131 from '../../assets/agricversedeviceimg/IMG_20250620_094322_131.jpg';
import img20250620_094357_885 from '../../assets/agricversedeviceimg/IMG_20250620_094357_885.jpg';
import img20250625_145603_145 from '../../assets/agricversedeviceimg/IMG_20250625_145603_145.jpg';
import img20250703_185722025 from '../../assets/agricversedeviceimg/IMG_20250703_185722025.jpg';
import img20250703_190435349 from '../../assets/agricversedeviceimg/IMG_20250703_190435349.jpg';
import img20250703_190542724 from '../../assets/agricversedeviceimg/IMG_20250703_190542724.jpg';
import img20250313Wa0021 from '../../assets/agricversedeviceimg/IMG-20250313-WA0021.jpeg';
import img20250527Wa0001 from '../../assets/agricversedeviceimg/IMG-20250527-WA0001.jpg';
import img20250527Wa0004 from '../../assets/agricversedeviceimg/IMG-20250527-WA0004.jpg';
import img20250527Wa0005 from '../../assets/agricversedeviceimg/IMG-20250527-WA0005.jpg';
import img20250527Wa0007 from '../../assets/agricversedeviceimg/IMG-20250527-WA0007.jpg';
import img20250527Wa0012 from '../../assets/agricversedeviceimg/IMG-20250527-WA0012.jpg';
import img20250812Wa0033 from '../../assets/agricversedeviceimg/IMG-20250812-WA0033.jpg';
import img20250924Wa0032 from '../../assets/agricversedeviceimg/IMG-20250924-WA0032.jpg';
import img20251008Wa0032 from '../../assets/agricversedeviceimg/IMG-20251008-WA0032.jpg';
import img20251008Wa0033 from '../../assets/agricversedeviceimg/IMG-20251008-WA0033.jpg';
import img20251008Wa0036 from '../../assets/agricversedeviceimg/IMG-20251008-WA0036.jpg';
import trainBatch0 from '../../assets/agricversedeviceimg/train_batch0.jpg';
import trainBatch2 from '../../assets/agricversedeviceimg/train_batch2.jpg';
import trainBatch2600 from '../../assets/agricversedeviceimg/train_batch2600.jpg';
import trainBatch2601 from '../../assets/agricversedeviceimg/train_batch2601.jpg';
import valBatch0Labels from '../../assets/agricversedeviceimg/val_batch0_labels.jpg';
import valBatch1Labels from '../../assets/agricversedeviceimg/val_batch1_labels.jpg';
import valBatch1Pred from '../../assets/agricversedeviceimg/val_batch1_pred.jpg';
import valBatch2Labels from '../../assets/agricversedeviceimg/val_batch2_labels.jpg';
import valBatch2Pred from '../../assets/agricversedeviceimg/val_batch2_pred.jpg';

gsap.registerPlugin(ScrollTrigger);

const GallerySection = () => {
  const sectionRef = useRef(null);
  const galleryRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const galleryImages = [

    { src: fieldHarvest1, alt: 'Field harvest device capture' },
    { src: img20240918Burst0005, alt: 'Device capture IMG_20240918_083133967_BURST0005' },
    { src: img20240924_155616_465, alt: 'Device capture IMG_20240924_155616_465' },
    { src: img20240928_101509_795, alt: 'Device capture IMG_20240928_101509_795' },
    { src: img20250527Wa0005, alt: 'Device capture IMG-20250527-WA0005' },
    { src: img20250527Wa0007, alt: 'Device capture IMG-20250527-WA0007' },
    { src: img20250527Wa0012, alt: 'Device capture IMG-20250527-WA0012' },
    { src: img20250812Wa0033, alt: 'Device capture IMG-20250812-WA0033' },
    { src: img20240928_101542_366, alt: 'Device capture IMG_20240928_101542_366' },
    { src: img20240930_142312_483, alt: 'Device capture IMG_20240930_142312_483' },
    { src: img20240930_142320_959, alt: 'Device capture IMG_20240930_142320_959' },
    { src: img20241001_123740_344, alt: 'Device capture IMG_20241001_123740_344' },
    { src: img20250620_094322_131, alt: 'Device capture IMG_20250620_094322_131' },
    { src: img20250620_094357_885, alt: 'Device capture IMG_20250620_094357_885' },
    { src: img20250625_145603_145, alt: 'Device capture IMG_20250625_145603_145' },
    { src: img20250703_185722025, alt: 'Device capture IMG_20250703_185722025' },
    { src: img20250703_190435349, alt: 'Device capture IMG_20250703_190435349' },
    { src: img20250703_190542724, alt: 'Device capture IMG_20250703_190542724' },
    { src: img20250313Wa0021, alt: 'Device capture IMG-20250313-WA0021' },
    { src: img20250527Wa0001, alt: 'Device capture IMG-20250527-WA0001' },
    { src: img20250527Wa0004, alt: 'Device capture IMG-20250527-WA0004' },
    { src: trainBatch2601, alt: 'Training batch 2601 visualization' },
    { src: valBatch0Labels, alt: 'Validation batch 0 labels' },
    { src: valBatch1Labels, alt: 'Validation batch 1 labels' },
    { src: img20250924Wa0032, alt: 'Device capture IMG-20250924-WA0032' },
    { src: img20251008Wa0032, alt: 'Device capture IMG-20251008-WA0032' },
    { src: img20251008Wa0033, alt: 'Device capture IMG-20251008-WA0033' },
    { src: img20251008Wa0036, alt: 'Device capture IMG-20251008-WA0036' },
    { src: trainBatch0, alt: 'Training batch 0 visualization' },
    { src: trainBatch2, alt: 'Training batch 2 visualization' },
    { src: trainBatch2600, alt: 'Training batch 2600 visualization' },
    { src: valBatch1Pred, alt: 'Validation batch 1 prediction' },
    { src: valBatch2Labels, alt: 'Validation batch 2 labels' },
    { src: valBatch2Pred, alt: 'Validation batch 2 prediction' },
    { src: img20241001_123901_897, alt: 'Device capture IMG_20241001_123901_897' },
    { src: img20250106_151509_066, alt: 'Device capture IMG_20250106_151509_066' },
    { src: img20250408_075039_133, alt: 'Device capture IMG_20250408_075039_133' },
    { src: img20250408_075041_574, alt: 'Device capture IMG_20250408_075041_574' },
    { src: img20250615_181910_807, alt: 'Device capture IMG_20250615_181910_807' },
    { src: img20250620_094314_385, alt: 'Device capture IMG_20250620_094314_385' },
  ];

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(sectionRef.current, {
        opacity: 0,
        y: 60,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      });

      // Animate gallery items
      gsap.from('.gallery-item', {
        scale: 0.8,
        opacity: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: 'back.out(1.7)',
        scrollTrigger: {
          trigger: galleryRef.current,
          start: 'top 70%',
          toggleActions: 'play none none reverse',
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  // Auto-play carousel
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, galleryImages.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000); // Resume after 10s
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  // Touch handlers for swipe
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) nextSlide();
    if (isRightSwipe) prevSlide();
  };

  const handlers = {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };

  return (
    <section ref={sectionRef} className="gallery-section" id="gallery">
      <div className="gallery-container">
        <div className="section-header">
          <span className="section-label">Visual Showcase</span>
          <h2 className="section-title">
            Explore Our
            <span className="gradient-text"> Platform</span>
          </h2>
          <p className="section-description">
            Take a visual journey through our AI powered device.
          </p>
        </div>

        <div {...handlers} ref={galleryRef} className="gallery-carousel">
          <div className="carousel-viewport">
            <div
              className="carousel-track"
              style={{
                transform: `translateX(-${currentIndex * 100}%)`,
              }}
            >
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <div className="gallery-image-wrapper">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="gallery-image"
                      loading="lazy"
                    />
                    <div className="gallery-overlay">
                      <span className="image-number">
                        {String(index + 1).padStart(2, '0')} / {String(galleryImages.length).padStart(2, '0')}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button className="carousel-nav carousel-prev" onClick={prevSlide} aria-label="Previous">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button className="carousel-nav carousel-next" onClick={nextSlide} aria-label="Next">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <div className="carousel-indicators">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentIndex ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;

